/* globals updateEventBind, addQueryParam */
(function () {
	'use strict';

	angular.module('app.dashboard')
		.controller('inventoryActionResultsCtrl', inventoryActionResultsCtrl);

	function inventoryActionResultsCtrl($scope, config, leanFilterService,
			dashboardFilterInitializationService, $timeout, $rootScope,
			inventoryActionResultsService, pageTimingService,
			storeService, $translate, timePeriodRadioOption, pastTimePeriodValue,
			futureTimePeriodValue, customDateOne, customDateTwo) {
		$scope.ignoreFilters = ['responsibleNdx', 'taskCategory', 'taskStatus'];
		$scope.filterService = dashboardFilterInitializationService;
		$scope.leanFilterService = leanFilterService;
		$scope.isReadOnly = storeService.getState().reportSettings.readOnly;

		$scope.$parent.$parent.showViewReport = true;
		$scope.editingWidget = false;

		$scope.slideshowView = $rootScope.slideshowView;

		$scope.pastTimePeriods = [{
			'name': $translate.instant('All'),
			'value': 'all'
		}, {
			'name': $translate.instant('30 Days Back'),
			'value': '30'
		}, {
			'name': $translate.instant('90 Days Back'),
			'value': '90'
		}, {
			'name': $translate.instant('180 Days Back'),
			'value': '180'
		}, {
			'name': $translate.instant('1 Year Back'),
			'value': '365'
		}, {
			'name': $translate.instant('Previous Fiscal Year'),
			'value': 'previous'
		}, {
			'name': $translate.instant('Current Fiscal YTD'),
			'value': 'currentFiscalYTD'
		}, {
			'name': $translate.instant('Custom'),
			'value': 'custom'
		}];

		$scope.futureTimePeriods = [{
			'name': $translate.instant('All'),
			'value': 'all'
		}, {
			'name': $translate.instant('30 Days Forward'),
			'value': '-30'
		}, {
			'name': $translate.instant('90 Days Forward'),
			'value': '-90'
		}, {
			'name': $translate.instant('180 Days Forward'),
			'value': '-180'
		}, {
			'name': $translate.instant('1 Year Forward'),
			'value': '-365'
		}, {
			'name': $translate.instant('Current Fiscal Year'),
			'value': 'current'
		}, {
			'name': $translate.instant('Custom'),
			'value': 'custom'
		}];

		$scope.timePeriodRadioOption = timePeriodRadioOption;
		$scope.pastTimePeriod = _.find($scope.pastTimePeriods, {value: pastTimePeriodValue});
		$scope.futureTimePeriod = _.find($scope.futureTimePeriods, {value: futureTimePeriodValue});
		$scope.customDateOne = new Date(customDateOne);
		$scope.customDateTwo = new Date(customDateTwo);
		$scope.pastDatePickerOptions = {
			datepickerMode : 'month',
			minMode: 'month',
			maxDate: new Date()
		};
		$scope.futureDatePickerOptions = {
			datepickerMode : 'month',
			minMode: 'month',
			minDate: new Date()
		};
		$scope.saveTimePeriod = function (timePeriodRadioOption, pastTimePeriod, futureTimePeriod) {
			if (timePeriodRadioOption !== null) {
				pendo.track('widgetChangeConfig', {
					widgetType: $scope.config.type,
					timePeriodRadioOption: timePeriodRadioOption,
					pastTimePeriod: pastTimePeriod ? pastTimePeriod.value : null,
					futureTimePeriod: futureTimePeriod ? futureTimePeriod.value : null,
					customDateOne: customDateOne,
					customDateTwo: customDateTwo
				});
				$scope.useConfig = true;
				$scope.editingWidget = false;
				$scope.$parent.$parent.hidePencil = false;
				updateWidgetConfig();
				getChart();
			}
		};
		$scope.openOne = function() {
			$scope.openedOne = true;
		};
		$scope.openTwo = function() {
			$scope.openedTwo = true;
		};

		function updateWidgetConfig() {
			var model = $scope.$parent.model;
			if ($scope.useConfig) {
				model.config.timePeriodRadioOption = $scope.timePeriodRadioOption;
				model.config.pastTimePeriod = $scope.pastTimePeriod ? $scope.pastTimePeriod.value : null;
				model.config.futureTimePeriod = $scope.futureTimePeriod ? $scope.futureTimePeriod.value : null;
				model.config.customDateOne = $scope.customDateOne;
				model.config.customDateTwo = $scope.customDateTwo;
			}
			var columnDefinition = $scope.$parent.$parent.col;
			storeService.dispatch({
				type: storeService.actions.CONFIG_WIDGET_UPDATE_ONE,
				payload: {
					column: 'column' + columnDefinition.columnIndex,
					position: columnDefinition.widgets.indexOf(model),
					widget: {
						name: model.config.type,
						config: _.cloneDeep(model.config)
					}
				},
				meta: {
					reportName: undefined,
					reportSettingsId: globalReportName
				}
			});
		}

		updateEventBind($scope, ['sideBarUpdate', 'adfFactoryChanged',
			'slideshowViewChanged', 'inventoryFilterChanged']);

		function getChart() {
			var columnDefinition = $scope.$parent.$parent.col;
			var curWidget = $scope.$parent.model;
			var reportingPeriods = [];
			if ($scope.timePeriodRadioOption)
				var timePeriodPast = $scope.timePeriodRadioOption != 'future' ? $scope.pastTimePeriod.value : null;
			var timePeriodFuture = $scope.timePeriodRadioOption != 'past' ? $scope.futureTimePeriod.value : null;
			inventoryActionResultsService.getInventoryActionResultsData(
				$scope.leanFilterService, $scope.ignoreFilters, timePeriodPast, timePeriodFuture, $scope.customDateOne, $scope.customDateTwo)
				.then(
					function (d) {
						$scope.chartData = d.data;
						$scope.currency = d.currency;
						angular.forEach($scope.chartData, function (dp) {
							dp['Fixed'] = dp.numFixed ? dp.numFixed : 0;
							dp['Unable to Fix'] = dp.numUnableToFix ? dp.numUnableToFix : 0;
							dp['Expired'] = dp.numExpired ? dp.numExpired : 0;
							dp['Open'] = dp.numOpen ? dp.numOpen : 0;
							dp['Total'] = dp['Fixed'] + dp['Unable to Fix'] + dp['Open'] + dp['Expired'];
							if (reportingPeriods.indexOf(dp.reportingPeriods) == -1) {
								reportingPeriods.push(dp.reportingPeriods);
							}
						});
						$scope.empty = !$scope.chartData || !$scope.chartData.length;
						$scope.$broadcast('event:inventoryActionResultsCtrl:getChart', null);
						if (!$scope.slideshowView) {
							pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
						}
						setDrilldown(reportingPeriods);
					},
					function (e) {
						$scope.empty = true;
						$scope.chartData = [];
						$scope.$broadcast('event:inventoryActionResultsCtrl:getChart', null);
						if (!$scope.slideshowView) {
							pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
						}
						setDrilldown();
					}
				);
		}

		function loadData() {
			if (!dashboardFilterInitializationService.updating['initialLoad']) {
				var columnDefinition = $scope.$parent.$parent.col;
				var curWidget = $scope.$parent.model;
				if (!$scope.slideshowView) {
					dashboardFilterInitializationService.markWidgetCreated('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
				}
				getChart();
			} else {
				$timeout(loadData, 100);
			}
		}

		function setDrilldown(reportingPeriods) {
			var filterQueryParams = $scope.leanFilterService.getQueryParamsObject(true, true);
			filterQueryParams['drilldown'] = 1;
			filterQueryParams['factory'] = $scope.leanFilterService.getFactoryList();
			filterQueryParams['sort'] = 'potentialSavings';
			filterQueryParams['sortDesc'] = 1;
			if (reportingPeriods) {
				filterQueryParams['reportingPeriod'] = reportingPeriods.join(',');
			}
			filterQueryParams = _.omit(filterQueryParams, $scope.ignoreFilters);
			$scope.$parent.$parent.widget.drillDownUrl = addQueryParam(
				'/application/f/home.html#/supply-chain/inventory-actions/', null, filterQueryParams);
		}

		$scope.$parent.$parent.editWidgetSettings = function () {
			$scope.editingWidget = true;
			$scope.$parent.$parent.hidePencil = true;
		};

		loadData();
	}
})();
